<template>
  <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12" style="height: 100%;" >
    <div class="card h-100 pb-3 pt-3">
      <div class="card-header">
        <h4 class="text-center fw-600">Mediavine</h4>
      </div>
      <div class="card-body pb-0">
        <div class="pt-10 pl-20 pr-20">
          <div class="row">
            <div class="col-md-3">
              <div style="background: #f2f2f2" class="card">
                <div class="card-body d-flex align-items-center">
                  <div class="col-12 col-md-12">
                    <div class="numbers d-flex flex-column">
                      <p class="card-category text-info fw-600">
                        Total Mediavine
                      </p>
                      <p class="card-title">{{ domains.length }}</p><p>
                    </p></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div style="background: #f2f2f2" class="card">
                <div class="card-body d-flex align-items-center">
                  <div class="col-12 col-md-12">
                    <div class="numbers d-flex flex-column">
                      <p class="card-category text-success fw-600">
                        Active mediavine
                      </p>
                      <p class="card-title">{{getActiveMediavine}}</p><p>
                    </p></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div style="background: #f2f2f2" class="card">
                <div class="card-body d-flex align-items-center">
                  <div class="col-12 col-md-12">
                    <div class="numbers d-flex flex-column">
                      <p class="card-category text-danger fw-600">
                        Requires Attention
                      </p>
                      <p class="card-title">{{getRequireAttentionMediavine}}</p><p>
                    </p></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div style="background: #f2f2f2" class="card">
                <div class="card-body d-flex align-items-center">
                  <div class="col-12 col-md-12">
                    <div class="numbers d-flex flex-column">
                      <p class="card-category text-warning fw-600">
                        Suspended
                      </p>
                      <p class="card-title">{{getSuspendedMediavine}}</p><p>
                    </p></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-8"></div>
            <div class="col-md-4 text-right">
              <button v-if="user.email === 'sara@bigscoots.com'"  @click="refreshAll()" class="btn btn-sm btn-primary">Refresh All</button>
              <button data-toggle="tooltip" data-placement="top" rel="tooltip" title="This will export all Mediavine sites that are ready for Cloudflare Route activation." v-show="!exportClicked" @click="exportCSV()" type="button" :disabled="exportLoading" class="btn btn-primary btn-sm">
                <div v-if="exportLoading" class="loader mini_loader"></div><span v-else class="">Generate CSV</span>
              </button>
              <vue-json-to-csv v-show="exportClicked" :json-data="getJSON" :labels="labels" :csv-title="getTitleForCsv()">
                <button id="export" type="button" :disabled="exportLoading" class="btn btn-primary btn-sm mr-4">
                  Generate CSV
                </button>
              </vue-json-to-csv>
            </div>
          </div>
          <div class="row mt-10">
            <div class="col-md-9 d-flex align-items-center">
              <div class="form-group mb-0">
                  <select @change="selectKeyFilter($event)" class="form-control" id="status">
                    <option selected value="default">Select status</option>
                    <option :disabled="checkIfExist('route')" value="route">Route status</option>
                    <option :disabled="checkIfExist('adsTxt')" value="adsTxt">Ads.txt status</option>
                    <option :disabled="checkIfExist('head')" value="head">Head status</option>
                    <option :disabled="checkIfExist('cfEnt')" value="cfEnt">CF Ent status</option>
<!--                    <option :disabled="checkIfExist('mvInt')" value="mvInt">MV status</option>-->
                </select>
              </div>
              <div class="form-group mb-0 ml-10">
                <select :disabled="!filters.key" @change="selectFilterVal($event)" class="form-control" id="value">
                  <option selected value="default">Select value</option>
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
              </div>
              <span v-for="(row, index) in selectedFilters" :key="index" class="badge badge-pill mr-4 ml-5" :class="row.color">{{ row.key }} <span class="text-dark fw-600">IS</span> {{row.value}} <i @click="removeFilter(row)" class="make-cursor-pointer fa fa-times-circle text-danger ml-2 fs-12"></i></span>
            </div>
            <div class="col-md-3 d-flex align-items-center justify-content-end">
              <div class="form-check">
                <label class="form-check-label">
                  <input class="form-check-input" value="journey" type="checkbox" v-model="plans">
                  Journey
                  <span class="form-check-sign">
                     <span class="check"></span>
                  </span>
                </label>
              </div>
              <div class="form-check ml-10">
                <label class="form-check-label">
                  <input class="form-check-input" value="mediavine" type="checkbox" v-model="plans">
                  Mediavine
                  <span class="form-check-sign">
                     <span class="check"></span>
                  </span>
                </label>
              </div>
              <div class="form-check ml-10">
                <label class="form-check-label">
                  <input class="form-check-input" type="checkbox" value="other" v-model="plans">
                  Other
                  <span class="form-check-sign">
                     <span class="check"></span>
                  </span>
                </label>
              </div>
            </div>
          </div>
          <div class="row mt-10">
            <div class="col-md-12">
              <table id="datatble" style="background-color: white" class="table table-bordered table-striped custom">
                <thead>
                <tr>
                  <th class="text-center">Domain</th>
                  <th class="text-center">Plan</th>
                  <th class="text-center">Route Register <i title="It shows the metadata of Cloudflare Route is valid." data-toggle="tooltip" data-placement="top" class="fa fa-info-circle make-cursor-pointer"></i></th>
                  <th class="text-center">Route Status <i title="It validates the route responsible for Mediavine Iframe is responding with 200 status code." data-toggle="tooltip" data-placement="top" class="fa fa-info-circle make-cursor-pointer"></i></th>
                  <th class="text-center">Ads.TXT Status <i title="It shows if the ads.txt is valid." data-toggle="tooltip" data-placement="top" class="fa fa-info-circle make-cursor-pointer"></i></th>
                  <th class="text-center">HEAD Code Status <i title="This verifies that the HTML code in the site's <head> section is correct, indicating that WordPress is properly configured to display ads from the correct Mediavine or Journey account." data-toggle="tooltip" data-placement="top" class="fa fa-info-circle make-cursor-pointer"></i></th>
                  <th class="text-center">CF ENT Status <i title="It confirms if the site is routing through our Cloudflare Enterprise hostname." data-toggle="tooltip" data-placement="top" class="fa fa-info-circle make-cursor-pointer"></i></th>
                  <th class="text-center">MV Status <i title="It ensures everything is working properly for a site to take benefits of our Mediavine Integration." data-toggle="tooltip" data-placement="top" class="fa fa-info-circle make-cursor-pointer"></i></th>
                  <th class="text-center">Actions</th>
                </tr>
                </thead>
                <tbody>
                <tr :style="row.status === 'suspended' ? 'background: #F5EFE5;' : ''" v-for="(row, index) in modifiedDomains" :key="index">
                  <td width="15%" class="text-center">{{ row.domain }}</td>
                  <td class="text-center">{{ row.planName && row.planName.includes('Mediavine') ? 'Mediavine' : (row.planName && row.planName.includes('Journey') ? 'Journey' : row.planName || '' )}}</td>
                  <td class="text-center">
                    <span v-if="row.mediavine && row.mediavine.routeStatus">
                      <span v-if="row.mediavine.routeStatus === 'active' || (row.mediavine.routeStatusResponse === 'journey' && row.planName.toLowerCase().includes('mediavine'))" class="badge badge-pill badge-success">{{ row.mediavine.routeStatusResponse }}</span>
                      <span v-else>
                        <template v-if="row.status === 'suspended'">
                          <span class="badge badge-warning badge-pill">Suspended</span>
                        </template>
                        <span data-toggle="tooltip" v-else-if="row.planName && !row.planName.toLowerCase().includes(row.routeStatusResponse) && (row.routeStatusResponse === 'mediavine')" :title="`Plan: ${row.planName} | Register Status: ${row.mediavine.routeStatusResponse}`" class="badge badge-pill badge-info make-cursor-pointer">
                          Mismatch
                        </span>
                        <span :title="`Register Status: ${row.mediavine.routeStatusResponse}`" data-toggle="tooltip" v-else class="badge badge-pill badge-danger make-cursor-pointer">
                          {{ row.mediavine.routeStatusResponse }}
<!--                          <i v-if="row.planName && !row.planName.toLowerCase().includes(row.routeStatusResponse)" :title="`Plan: ${row.planName} | Register Status: ${row.mediavine.routeStatusResponse}`" class="fa fa-info-circle make-cursor-pointer" data-toggle="tooltip" data-placement="top"></i>-->
                        </span>
                      </span>
                    </span>
                    <span v-else>-</span>
                  </td>
                  <td class="text-center">
                    <span v-if="row.mediavine && row.mediavine.newRouteStatus">
                      <span v-if="row.mediavine.newRouteStatus === 'active'" class="badge badge-pill badge-success">Active</span>
                      <span v-else>
                        <template v-if="row.status === 'suspended'">
                          <span class="badge badge-warning badge-pill">Suspended</span>
                        </template>
                        <span v-else class="badge badge-pill badge-danger">
                          Requires Attention
                          <i v-if="row.planName && !row.planName.toLowerCase().includes(row.newRouteStatusResponse)" :title="`Plan: ${row.planName} | Route Status: ${row.mediavine.newRouteStatusResponse.message}`" class="fa fa-info-circle make-cursor-pointer" data-toggle="tooltip" data-placement="top"></i>
                        </span>
                      </span>
                    </span>
                    <span v-else>-</span>
                  </td>
                  <td class="text-center">
                    <span v-if="row.mediavine && row.mediavine.adStatus">
                      <span v-if="row.mediavine.adStatus === 'active' || row.mediavine.adStatusResponse.mv_status === 'journey' && row.planName.toLowerCase().includes('mediavine')" class="badge badge-pill badge-success">{{ row.mediavine.adStatusResponse.mv_status }}</span>
                      <span v-else>
                        <span v-if="row.status === 'suspended'" class="badge badge-warning badge-pill">Suspended</span>
                        <span :title="`Ads.Txt Status: ${row.mediavine.adStatusResponse.mv_status}`" data-toggle="tooltip" v-else-if="row.planName && !row.planName.toLowerCase().includes(row.mediavine.adStatusResponse.mv_status) && (row.mediavine.adStatusResponse.mv_status === 'mediavine')" class="make-cursor-pointer badge badge-pill badge-info">Mismatch
                        </span>
                        <span v-else data-toggle="tooltip" :title="`Ads.Txt Status: ${row.mediavine.adStatusResponse.mv_status}`" class="badge badge-pill badge-danger make-cursor-pointer" >
                          {{ row.mediavine.adStatusResponse.mv_status || 'Undefined' }}
                        </span>
                      </span>
                    </span>
                    <span v-else>-</span>
                  </td>
                  <td class="text-center">
                    <span v-if="row.mediavine && row.mediavine.headStatus">
                      <span v-if="row.mediavine.headStatus === 'active' || (row.mediavine.headStatusResponse.wrapper === 'journey' && row.planName.toLowerCase().includes('mediavine'))" class="badge badge-pill badge-success">{{ row.mediavine.headStatusResponse.wrapper }}</span>
                      <template v-else>
                        <span v-if="row.status === 'suspended'" class="badge badge-warning badge-pill">Suspended</span>
                        <span class="badge badge-pill badge-info make-cursor-pointer" :title="`Head Status: ${row.mediavine.headStatusResponse.wrapper}`" data-toggle="tooltip" v-else-if="row.mediavine && row.mediavine.headStatusResponse && !row.planName.toLowerCase().includes(row.mediavine.headStatusResponse.wrapper) && (row.mediavine.headStatusResponse.wrapper === 'mediavine')">
                          Mismatch
                        </span>
                        <span :title="`Head Status: ${row.mediavine.headStatusResponse.wrapper}`" data-toggle="tooltip" class="badge badge-pill badge-danger make-cursor-pointer" v-else>
                          {{ row.mediavine.headStatusResponse.wrapper || 'Undefined' }}
                        </span>
                      </template>
                    </span>
                    <span v-else>-</span>
                  </td>
                  <td class="text-center">
                    <span v-if="row.mediavine && row.mediavine.cfEnterpriseStatus">
                      <span v-if="row.mediavine.cfEnterpriseStatus === 'active' && row.status !== 'suspended'" class="badge badge-pill badge-success">Active</span>
                      <template v-else >
                        <template v-if="row.status === 'suspended'">
                          <span class="badge badge-warning badge-pill">Suspended</span>
                        </template>
                        <span v-else class="badge badge-pill badge-danger">Requires Attention</span>
                      </template>
                    </span>
                    <span v-else>-</span>
                  </td>
                  <td class="text-center">
                    <span v-if="row.mediavine">
                      <span v-if="row.mediavine.cfEnterpriseStatus === 'active' && row.mediavine.adStatus === 'active' && row.mediavine.routeStatus === 'active' && row.mediavine.headStatus === 'active' && row.status !== 'suspended'" class="badge badge-pill badge-success">Active</span>
                      <template v-else >
                       <template v-if="row.status === 'suspended'">
                        <span class="badge badge-warning badge-pill">Suspended</span>
                      </template>
                        <span class="badge badge-pill badge-success" v-else-if="row.planName.toLowerCase().includes('mediavine') && ((row.mediavine.routeStatusResponse === 'journey' || row.mediavine.routeStatusResponse === 'mediavine') && (row.mediavine.adStatusResponse.mv_status === 'journey' || row.mediavine.adStatusResponse.mv_status === 'mediavine') && (row.mediavine.headStatusResponse.wrapper === 'journey' || row.mediavine.headStatusResponse.wrapper === 'mediavine'))">Active</span>
                      <span v-else class="badge badge-pill badge-danger">Requires Attention</span>
                      </template>

                    </span>
                    <span v-else>-</span>
                  </td>
                  <td width="15%" class="td-actions text-center">
                    <div class="bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate" :class="{ 'bootstrap-switch-on bootstrap-switch-focused' : row.mediavine && row.mediavine.routeStatus === 'active', 'bootstrap-switch-off bootstrap-switch-focused' : !row.mediavine || row.mediavine.routeStatus !== 'active' }">
                      <div class="bootstrap-switch-container" @click="changeRouteRegister(row, index)">
                        <span class="bootstrap-switch-handle-on bootstrap-switch-success">On</span>
                        <span class="bootstrap-switch-label"></span>
                        <span class="bootstrap-switch-handle-off bootstrap-switch-default">Off</span>
                      </div>
                    </div>
                    <button @click="refreshStatus(row, index)" type="button" rel="tooltip" class="btn btn-primary btn-sm btn-round btn-icon mr-4">
                      <i v-if="selectedIndex === index" style="top: 10%;left: 10%" class="fa fa-spin fa-spinner"></i>
                      <i v-else class="fa fa-refresh"></i>
                    </button>
                    <button @click="loginAsUser(row)" title="Login as user" data-toggle="tooltip" data-placement="top" type="button" rel="tooltip" class="btn btn-info btn-sm btn-round btn-icon mr-4">
                      <i class="fa fa-user"></i>
                    </button>
                    <button @click="openUserAccountonAdminSide(row)" type="button" rel="tooltip" title="Go to user account" data-toggle="tooltip" data-placement="top" class="btn btn-success btn-sm btn-round btn-icon mr-4">
                      <i class="fa fa-edit"></i>
                    </button>
                    <button @click="openUserAccountonHostbill(row)" type="button" rel="tooltip" title="Go to user's hostBill account" data-toggle="tooltip" data-placement="top" class="btn btn-danger btn-sm btn-round btn-icon">
                      <i class="fa fa-external-link"></i>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
<!--              <template v-if="!domains.length">-->
<!--                <div class="row">-->
<!--                  <div class="col-md-12 text-center text-danger mb-3 font-weight-bold">-->
<!--                    No Domain Exists-->
<!--                  </div>-->
<!--                </div>-->
<!--              </template>-->
<!--              <div class="row mt-10" v-if="domains.length > 0 ">-->
<!--                <div class="col-md-12 d-flex justify-content-between">-->
<!--                    <span class="lh-3 pull-left">-->
<!--                       <b>Page {{pageMainNum + 1}} of {{mainPageCount}}</b>-->
<!--                    </span>-->
<!--                  <section class="dataTables_paginate paging_full_numbers">-->
<!--                    <paginate-->
<!--                        id="notes"-->
<!--                        :pageCount="mainPageCount"-->
<!--                        :clickHandler="goToMainPage"-->
<!--                        :prevText="'Prev'"-->
<!--                        :nextText="'Next'"-->
<!--                        page-class="page-item"-->
<!--                        prev-class="page-item"-->
<!--                        prev-link-class="page-link"-->
<!--                        next-class="page-item"-->
<!--                        next-link-class="page-link"-->
<!--                        page-link-class="page-link"-->
<!--                        containerClass="pagination">-->
<!--                    </paginate>-->
<!--                  </section>-->
<!--                </div>-->
<!--              </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {db} from "@/firebase/init";
import Paginate from 'vuejs-paginate'
import ActivateCFModal from "@/components/Admin/Tasks/activateCFModal.vue";
import swal from "sweetalert2";
import moment from "moment/moment";
import VueJsonToCsv from 'vue-json-to-csv'

export default {
  components: { Paginate, VueJsonToCsv },
  beforeDestroy() {
    if(this.listener) {
      this.listener()
    }
  },
  data () {
    return {
      labels: {},
      exportClicked: false,
      exportLoading: false,
      statusDbValues: {
        'head': 'headStatus',
        'cfEnt': 'cfEnterpriseStatus',
        'route': 'routeStatus',
        'adsTxt': 'adStatus',
      },
      selectedFilters: [],
      filters: {},
      domains: [],
      listener: null,
      loading: false,
      pageMainNum: 0,
      pageMainSize: 10,
      selectedIndex: -1,
      plans: ['journey', 'mediavine', 'other'],
      json: []
    }
  },
  mounted() {
    this.loading = true
    this.fetchDomains()
    this.renderDatatable()
    $(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
    this.loading = false
  },
  watch: {
    modifiedDomains(val) {
      this.renderDatatable()
    }
  },
  computed: {
    modifiedDomains() {
      let array = [];
      for(const el of this.domains) {
        if(this.plans.includes('journey')) {
          if(el.planName && el.planName.includes('Journey')){
            array.push(el);
          }
        }
        if(this.plans.includes('mediavine')) {
          if(el.planName && el.planName.includes('Mediavine')){
            array.push(el);
          }
        }
        if(this.plans.includes('other')) {
          if((el.planName && !el.planName.includes('Mediavine') && !el.planName.includes('Journey')) || !el.planName){
            array.push(el);
          }
        }
      }
      let finalArray = []
      if(this.selectedFilters.length) {
        array = array.map(el => {
          let shouldAdd = true
          this.selectedFilters.map(el2 => {
            console.log(this.statusDbValues[el2.key],el.mediavine && el.mediavine[this.statusDbValues[`${el2.key}`]], el.mediavine)
            if(el.mediavine && el.mediavine[`${this.statusDbValues[el2.key]}`] !== el2.value) {
              shouldAdd = false
            }
            console.log('shouldAdd', shouldAdd)
          })
          if(shouldAdd) {
            finalArray.push(el)
          }
        })
      } else {
        finalArray = array
      }
      return finalArray;
    },
    getActiveMediavine() {
      let count = 0
      for(const row of this.domains) {
        if(row.mediavine && row.mediavine.routeStatus === 'active' && row.mediavine.adStatus === 'active' && row.mediavine.headStatus === 'active' && row.mediavine.cfEnterpriseStatus === 'active' && row.status !== 'suspended') {
          count = count + 1
        }
      }
      return count
    },
    getJSON() {
      const array = [];
      for(const row of this.domains) {
        if(row.mediavine && row.mediavine.routeStatus === 'inactive' && row.mediavine.adStatus === 'active' && row.mediavine.headStatus === 'active' && row.mediavine.cfEnterpriseStatus === 'active' && row.status !== 'suspended') {
          array.push({ domain: row.domain, adsTxtStatus: row.mediavine.adStatus, cfEntStatus: row.mediavine.cfEnterpriseStatus, headCodeStatus: row.mediavine.headStatus})
        }
      }
      return array
    },
    getSuspendedMediavine() {
      let count = 0
      for(const row of this.domains) {
        if(row.status === 'suspended') {
          count = count + 1
        }
      }
      return count
    },
    getRequireAttentionMediavine() {
      let count = 0
      for(const row of this.domains) {
        if((!row.mediavine || row.mediavine.routeStatus !== 'active' || row.mediavine.headStatus !== 'active' || row.mediavine.adStatus !== 'active' || row.mediavine.cfEnterpriseStatus !== 'active') && row.status !== 'suspended') {
          count = count + 1
        }
      }
      return count
    },
    mainPageCount(){
      if(this.domains && this.domains.length > 0) {
        let filteredGroups = this.domains
        let l = filteredGroups.length, s = this.pageMainSize;
        return Math.ceil(l/s);
      }
    },
    paginatedDomains() {
      const start = this.pageMainNum * this.pageMainSize, end = start + this.pageMainSize;
      const allTasks = this.domains.slice(start, end);
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return allTasks
    },
  },
  methods: {
    getTitleForCsv(){
      return `Mediavine_sites_${(new Date()).getTime()}`
    },
    async exportCSV(val){
      try {
        console.log('im called', val)
        this.exportLoading = true
        this.labels = {
          domain: { title: 'Domain' },
          adsTxtStatus: { title: 'Ads.TXT status' },
          headCodeStatus: {title: 'Head Code Status'},
          cfEntStatus: { title: 'CF ENT status' },
        }
        this.exportClicked = true;
        setTimeout(function() {
          const button = document.getElementById("export");
          button.click();
          this.exportClicked = false
        }, 500);
      } catch (e) {
        this.exportLoading = false
        console.log('error 273', e.toString())
      } finally {
        this.exportLoading = false
        this.exportClicked = false
      }
    },
    removeFilter(e) {
      this.selectedFilters = this.selectedFilters.filter(el => el.key !== e.key)
    },
    checkIfExist(e){
      return this.selectedFilters.find(el => el.key === e)
    },
    selectFilterVal(e) {
      let color = ''
      const {key} = this.filters;
      if(key === 'mvInt') {
        color = 'badge-danger'
      }if(key === 'route') {
        color = 'badge-warning'
      }if(key === 'cfEnt') {
        color = 'badge-primary'
      }if(key === 'adsTxt') {
        color = 'badge-success'
      }if(key === 'mvInt') {
        color = 'badge-info'
      }if(key === 'head') {
        color = 'badge-default'
      }
      this.selectedFilters.push({key: this.filters.key, value: e.target.value, color})
      this.filters = { }
      const el = document.getElementById('status');
      const el2 = document.getElementById('value');
      if(el) {
        el.value = 'default'
      }
      if(el2) {
        el2.value = 'default'
      }

    },
    selectKeyFilter(val) {
      console.log('selectFilterVal', val);
      this.filters = {key: val.target.value}
    },
    async refreshAll() {
      console.log()
      try {
        const response = await this.$http.post('/hostingAccounts/sync-mediavine-domains', {
          grant_type: 'token'
        })
        console.log('response', response.data)
        swal('Success', 'Request received for synchronizing status of all mediavine domains', 'success')
      } catch (e) {
        console.log(e.toString())
        swal('Error', 'Unable to refresh status!', 'error')
      } finally {
      }
    },
    async refreshStatus(data, index) {
      console.log(data)
      try {
        this.selectedIndex = index
        const response = await this.$http.post('/hostingAccounts/refresh-statuses-for-mediavine', {
          id: data.id,
          domain: data.domain,
          ip: data.ip,
          uid: data.uid,
          mediavine: data.mediavine,
          planName: data.planName,
          grant_type: 'token'
        })
        console.log('response', response.data)
      } catch (e) {
        console.log(e.toString())
        swal('Error', 'Unable to refresh status!', 'error')
      } finally {
        this.selectedIndex = -1
      }
    },
    async changeRouteRegister(data, index) {
      console.log(data)
      try {
        // this.selectedIndex = index
        const integration = !data.planName.includes('Mediavine') ? (data.planName.includes('Journey') ? 'journey' : 'none') : 'mediavine';
        console.log('integration', integration)
        const response = await this.$http.post('/hostingAccounts/change-route-register-for-mediavine', {
          id: data.id,
          domain: data.domain,
          integrations: data.mediavine ? (data.mediavine.routeStatus === 'active' ? 'none' : integration) :'none',
          grant_type: 'token'
        })
        console.log('response', response.data)
        this.showToast({duration: 8000,message: `You have successfully changed the route status.`}, true, 'success')
      } catch (e) {
        console.log(e.toString())
        swal('Error', 'Unable to refresh status!', 'error')
      } finally {
        this.selectedIndex = -1
      }
    },
    loginAsUser(data) {
      console.log(data)
      try {
        if (data.uid) {
          window.open(`https://wpo.bigscoots.com/user/dashboard?id=${data.uid}`, 'WPO-Bigscoots');
        }
      } catch (e) {
        console.log(e.toString())
        swal('Error', 'Unable to login to user account!', 'error')
      }
    },
    openUserAccountonAdminSide(data) {
      console.log(data)
      try {
        if (data.uid) {
          window.open(`/admin/edit-user/${data.uid}`);
        }
      } catch (e) {
        console.log(e.toString())
        swal('Error', 'Unable to login to user account!', 'error')
      }
    },
    async openUserAccountonHostbill(data) {
      console.log(data)
      try {
        if (data.uid) {
          const ref = await db.collection('users').doc(data.uid).get()
          if(ref.exists) {
            const {customerID} = ref.data()
            window.open(`https://portal.bigscoots.com/admin/?cmd=clients&action=show&id=${customerID}`);

          }
        }
      } catch (e) {
        console.log(e.toString())
        swal('Error', 'Unable to login to user account!', 'error')
      }
    },
    addFilter(key, value) {
      let color = null;
      let customkey = null;
      if(key === 'mvIntegration') {
        color = 'badge-danger'
        customkey = 'MV Integration'
      }if(key === 'workerStatus') {
        color = 'badge-warning'
        customkey = 'MV Integration'
        customkey = 'Worker Status'
      }if(key === 'cfEnterprise') {
        color = 'badge-primary'
        customkey = 'CF Enterprise'
      }if(key === 'adStatus') {
        color = 'badge-success'
        customkey = 'AD Status'
      }
      this.filters = this.filters.filter(el => el.key !== customkey)
      this.filters.push({key: customkey, value, color})
    },
    goToMainPage(pageNum) {
      this.pageMainNum = pageNum-1;
    },
    async fetchDomains() {
      try {
        this.loading = true;
        this.domains = []
        this.listener = await db.collection('domains').where('cfEnterprise.status', 'in', ['fail', 'running', 'pass'])  .where('cfPlan', '==', 'mediavine_integration').onSnapshot(querySnapshot => {
          querySnapshot.docChanges().forEach(changeDoc => {
            if (changeDoc.type === 'added'){
              this.domains.push({id: changeDoc.doc.id, ...changeDoc.doc.data()})
            }
            if(changeDoc.type === 'modified') {
              console.log('modified')
              const data = {id: changeDoc.doc.id, ...changeDoc.doc.data()}
              let taskToUpdate = this.domains.find((task) => task.id === data.id );
              const allKeys = Object.keys(data);
              for (const key of allKeys){
                taskToUpdate[key] = data[key];
              }
            }
            if(changeDoc.type === 'removed') {
              this.domains = this.domains.filter(el => el.id !== changeDoc.doc.id)
            }
          });
        });
        console.log('70', this.domains, this.domains.length)
        console.log('im calling again')
        $(function () {
          $('[data-toggle="tooltip"]').tooltip()
        })
        this.loading = false;
      } catch (e) {
        this.loading = false
        console.log('74', e.toString())
      } finally {
      }
    },
    renderDatatable() {
      console.log('rendering')
      if($.fn.DataTable.isDataTable('#datatble')) {
        $(`#datatble`).DataTable().destroy();
      }
      $(function () {
        $('[data-toggle="tooltip"]').tooltip();
      });
      setTimeout(function () {
        $(`#datatble`).dataTable({
          pagingType: "full_numbers",
          paging: true,
          destroy: true,
          retrieve: true,
          deferRender: true,
          stateSave: false,
          "bInfo" : false,
          "ordering": true,
          "columnDefs": [
            { "orderable": false, "targets": [8] } // Disable sorting on the first and third columns
          ],
          initComplete: function () {
            let api = this.api();
            $('.dataTables_filter input').on('input', function () {
              let newValue = $(this).val().replace(/\s/g, ''); // Remove spaces
              $(this).val(newValue);
              api.search(newValue).draw();
            });
          }
        });
      }, 0)
    },
  },
}
</script>


<style scoped>
.custom {
  .badge-success {
    background-color: #ddf6e8;
    color: #6bd098;
    font-weight: 700;
  }.badge-warning {
     background-color: #fff0e1;
     color: #fbc658;
     font-weight: 700;
   }.badge-danger {
     background-color: #FDEEED;
     color: #EE8157;
     font-weight: 700;
   }
}
.dropdown-toggle:after {
  display: none;
}
.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-default{
  background-color: #79c29a;
}
.badge-info{
  background: #50dbff3d;
  color: #3c98b7;
}
.badge{
  text-transform: capitalize;
}
</style>
